import { Routes } from '@angular/router';
import { publicRoutes } from './features/public.routes';
import { pacienteRoutes } from './features/paciente/paciente.routes';
import { profissionalRoutes } from './features/profissional/profissional.routes';
import { depositoRoutes } from './features/deposito/deposito.routes';
import { farmaciaRoutes } from './features/farmacia/farmacia.routes';
import { clinicaRoutes } from './features/clinica/clinica.routes';
import { adminRoutes } from './features/admin/admin.routes';

export const routes: Routes = [
  // Rotas públicas (home, login, registro, farmacias, planos, suporte)
  ...publicRoutes,
  
  // Rotas do painel do paciente
  ...pacienteRoutes,
  
  // Rotas do painel do profissional de saúde
  ...profissionalRoutes,
  
  // Rotas do painel do depósito
  ...depositoRoutes,
  
  // Rotas do painel da farmácia
  ...farmaciaRoutes,
  
  // Rotas do painel da clínica
  ...clinicaRoutes,
  
  // Rotas do painel do admin
  ...adminRoutes,
  
  // Rota 404 - deve ser sempre a última
  {
    path: '**',
    loadComponent: () => import('./features/error/not-found/not-found.component').then(m => m.NotFoundComponent)
  }
];